import { ChangeEvent, useState } from "react";
import { colord, extend } from "colord";
import lchPlugin from "colord/plugins/lch";
import { Input } from "shared/components/forms/Input";
import { cx } from "shared/utils";

extend([lchPlugin]);

interface ColorPickerProps {
  value: string;
  onChange: (color: string) => void;
  label?: string;
  placeholder?: string;
  defaultValue?: string;
  error?: string;
}

export const ColorPicker = ({
  value,
  onChange,
  label = "Primary color",
  placeholder = "#E6007E",
  error: externalError
}: ColorPickerProps) => {
  const [color, setColor] = useState(value);
  const [internalError, setInternalError] = useState("");
  const error = internalError || externalError || "";

  const handleColorChange = (e: ChangeEvent<HTMLInputElement>) => {
    const inputValue = e.target.value;
    const color = colord(inputValue);

    setColor(inputValue);

    if (color.isValid()) {
      const hexColor = color.toHex();
      onChange(hexColor);
      setInternalError("");
    } else setInternalError("Invalid value");
  };

  return (
    <div className="space-y-4">
      <div className="flex gap-2 items-end">
        <div className="flex-1">
          <Input
            id="primary-color"
            label={label}
            placeholder={placeholder}
            value={color}
            onChange={handleColorChange}
            error={error}
            required
          />
        </div>

        <input
          type="color"
          value={color || placeholder}
          onChange={handleColorChange}
          className={cx(
            "size-12 cursor-pointer rounded-lg bg-transparent border border-alpha-100 shadow-xs focus:border-primary-100 focus:shadow-focus-ring [&::-webkit-color-swatch-wrapper]:p-2 [&::-webkit-color-swatch]:rounded-md [&::-webkit-color-swatch]:border-none",
            error ? "mb-6" : "mb-2"
          )}
        />
      </div>
    </div>
  );
};
